<div class="h-full">
  <ngx-monaco-editor
    #editor
    [options]="{
      automaticLayout: false,
      minimap: { enabled: true },
      lineNumbers: 'on',
      contextmenu: false,
      wordBasedSuggestions: 'currentDocument',
      readOnly: (aiService.aiIsWriting$ | async) ?? false,
      wordWrap: 'on'
    }"
    [language]="language()"
    [value]="content"
    (valueChange)="onContentChange($event)"
    [theme]="'vs-light'"
    class="h-full"
  ></ngx-monaco-editor>
      <!-- (editorInitialized)="editorInitialized($event)"
    (focus)="onFocus()"
    (blur)="onBlur()" -->
</div>
